import '@rio-cloud/iframe-resizer/child';
import { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { config } from './config';
import { main } from './configuration';
import { store } from './configuration/setup/store';
import { handleLoginRedirect } from './configuration/login/redirect';
import { ErrorBoundary } from './components/ErrorBoundary';
import SuspendedWithSpinner from './components/SuspendedWithSpinner';
import AppLayout from './layout/AppLayout';

const CreateDialog = lazy(() => import('./pages/CreateDialogWrapper'));

const renderApplication = () => {
    createRoot(document.getElementById('root') as HTMLElement).render(
        <ErrorBoundary>
            <Provider store={store}>
                <SuspendedWithSpinner>
                    <AppLayout>
                        <CreateDialog />
                    </AppLayout>
                </SuspendedWithSpinner>
            </Provider>
        </ErrorBoundary>
    );
};

const isDev = import.meta.env.DEV;
const isProd = import.meta.env.PROD;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;

if ((isDev && config.enableMockServer) || isProdPreview) {
    import('../mocks/serviceMock').then(({ startWorker }) => startWorker()).then(() => main(renderApplication));
}

if (window.location.href.startsWith(config.login.redirectUri as string)) {
    void handleLoginRedirect();
} else if (isProd && !isProdPreview) {
    void main(renderApplication);
}
